import React, { useEffect } from "react";
import lottie from "lottie-web";
import logo from "./data-logo.json";

function Header() {
  const constructor = () => {
    lottie.loadAnimation({
      container: document.getElementById("lottie"), // the dom element that will contain the animation
      renderer: "svg",
      autoplay: true,
      loop: true,
      animationData: logo, // the path to the animation json
    });
  };
  useEffect(() => {
    constructor();
  }, []);
  return (
    <header>
      <div className="logo">
        <div id="lottie"></div>
      </div>
    </header>
  );
}

export default Header;
